import SinSVG from "../images/explore/struggle/mental.svg";
import PerspectiveSVG from "../images/explore/struggle/spiritual.svg";
import WisdomSVG from "../images/explore/emotion/pleasure.svg";

const questionArray = [
    {
        id: 1,
        name: "Life Wisdom",
        image: WisdomSVG,
        description: "Great! Since you seek wisdom, will you pick from one of these more specific questions?",
        details: [
        {
            id: 1,
            attributeName: 'eternal',
            name: 'Should I spend a dollar now or save it for later?',
            description: 'Click on the attribute for the answer!',
            groupId: 1},
            {
            id: 2,
            attributeName: 'faithful',
            name: 'Is reason better than faith?',
            description: 'Click on the attribute for the answer!',
            groupId: 1},
        {
            id: 3,
            attributeName: 'gracious',
            name: 'Do I need to hate all the things of this world in order to love God?',
            description: 'Click on the attribute for the answer!',
            groupId: 1},
        {
            id: 4,
            attributeName: 'jealous',
            name: 'How do I win God’s acceptance?',
            description: 'Click on the attribute for the answer!',
            groupId: 1},
        {
            id: 5,
            attributeName: 'just',
            name: 'How important is it in this unjust world to seek justice now?',
            description: 'Click on the attribute for the answer!',
            groupId: 1},
        {
            id: 6,
            attributeName: 'loving',
            name: 'Is idol worship just a thing of the past?',
            description: 'Click on the attribute for the answer!',
            groupId: 1},
        {
            id: 7,
            attributeName: 'merciful',
            name: 'To whom should I show the most mercy?',
            description: 'Click on the attribute for the answer!',
            groupId: 1},
        {
            id: 8,
            attributeName: 'planning',
            name: 'Is it better to plan on being poor or rich?',
            description: 'Click on the attribute for the answer!',
            groupId: 1},
        {
            id: 9,
            attributeName: 'relational',
            name: 'How can I best relate to other people?',
            description: 'Click on the attribute for the answer!',
            groupId: 1
        },
        {
            id: 10,
            attributeName: 'truthful',
            name: 'How can I know the Bible is really true?',
            description: 'Click on the attribute for the answer!',
            groupId: 1
        },
        {
            id: 11,
            attributeName: 'wise',
            name: 'Will having God’s wisdom save me from suffering?',
            description: 'Click on the attribute for the answer!',
            groupId: 1
        },
        ]
    },
    {
        id: 2,
        name: "Life Perspective",
        image: PerspectiveSVG,
        description: "Gaining perspective is great!  Can you help clarify by selecting one of these questions?",
        details: [
            {
                id: 1,
                attributeName: 'glorious',
                name: 'Does God receive more glory from what I do, or who I am?',
                description: 'Click on the attribute for the answer!',
                group: 'Life Perspective',
                groupId: 2
                },
                {
                id: 2,
                attributeName: 'good',
                name: 'Will my life ever get better?',
                description: 'Click on the attribute for the answer!',
                group: 'Life Perspective',
                groupId: 2
                },
                {
                id: 3,
                attributeName: 'humble',
                name: 'How do I discover who I really am?',
                description: 'Click on the attribute for the answer!',
                group: 'Life Perspective',
                groupId: 2
                },
                {
                id: 4,
                attributeName: 'incomprehensible',
                name: 'How do I make sense of truths that seem to oppose each other?',
                description: 'Click on the attribute for the answer!',
                group: 'Life Perspective',
                groupId: 2
                },
                {
                id: 5,
                attributeName: 'invisible',
                name: 'Will we be invisible in heaven?',
                description: 'Click on the attribute for the answer!',
                group: 'Life Perspective',
                groupId: 2
                },
                {
                id: 6,
                attributeName: 'omnipotent',
                name: 'Which has the most power - government, business, or the Church?',
                description: 'Click on the attribute for the answer!',
                group: 'Life Perspective',
                groupId: 2
                },
                {
                id: 7,
                attributeName: 'omnipresent',
                name: 'Is Christianity on the decline?',
                description: 'Click on the attribute for the answer!',
                group: 'Life Perspective',
                groupId: 2
                },
                {
                id: 8,
                attributeName: 'peaceful',
                name: 'Why am I stressed out all the time?',
                description: 'Click on the attribute for the answer!',
                group: 'Life Perspective',
                groupId: 2
                },
                {
                id: 9,
                attributeName: 'providing',
                name: 'How important is my current physical life since I will soon be in heaven?',
                description: 'Click on the attribute for the answer!',
                group: 'Life Perspective',
                groupId: 2
                },
                {
                id: 10,
                attributeName: 'sovereign',
                name: 'How much in life am I really free to decide?',
                description: 'Click on the attribute for the answer!',
                group: 'Life Perspective',
                groupId: 2
                },
                {
                id: 11,
                attributeName: 'unique',
                name: 'Are humans “little gods” or just another animal?',
                description: 'Click on the attribute for the answer!',
                group: 'Life Perspective',
                groupId: 2
                },
                {
                id: 12,
                attributeName: 'wrathful',
                name: 'Is Satan equal to, but just opposite of, Jesus?',
                description: 'Click on the attribute for the answer!',
                group: 'Life Perspective',
                groupId: 2
                },

        ]
    },
    {
        id: 3,
        name: "Dealing with Sin in Life",
        image: SinSVG,
        description: "Sin can make a mess of everything, but there is hope!  Pick the best question to ask.",
        details: [
            {
                id: 1,
                attributeName: 'independent',
                name: 'How do I know if I am worshipping myself?',
                description: 'Click on the attribute for the answer!'
            },
            {
                id: 2,
                attributeName: 'joyful',
                name: 'Does freedom bring me happiness?',
                description: 'Click on the attribute for the answer!'
            },
            {
                id: 3,
                attributeName: 'creative',
                name: 'What if my desires aren’t very godly?',
                description: 'Click on the attribute for the answer!'
            },
            {
                id: 4,
                attributeName: 'holy',
                name: 'As a Christian, is everything I do holy because of whose I am, or sinful because of where I am?',
                description: 'Click on the attribute for the answer!'
            },
            {
                id: 5,
                attributeName: 'immutable',
                name: 'Does my security in Christ cause me to lose freedom?',
                description: 'Click on the attribute for the answer!'
            },
            {
                id: 6,
                attributeName: 'omniscient',
                name: 'Does God know of and consider my motivations?',
                description: 'Click on the attribute for the answer!'
            },
            {
                id: 7,
                attributeName: 'patient',
                name: 'Should a Christian love or hate the world in which we are living?',
                description: 'Click on the attribute for the answer!'
            },
            {
                id: 8,
                attributeName: 'saving',
                name: 'Is my current problem my own fault - or am I just a victim?',
                description: 'Click on the attribute for the answer!'
            },
            {
                id: 9,
                attributeName: 'teaching',
                name: 'If God is my sovereign guide, do I even have any responsibility?',
                description: 'Click on the attribute for the answer!'
            },
                
        ]
    }
];

export default questionArray;